import api from '../../api/userAPI';
import { setErrorNotification } from '../snackbarNotification';

export const FETCH_BEGIN = 'doctor.listByAppointmentType/FETCH_BEGIN';
export const FETCH_SUCCESS = 'doctor.listByAppointmentType/FETCH_SUCCESS';
export const FETCH_FAILED = 'doctor.listByAppointmentType/FETCH_FAILED';

const fetchBegin = () => ({ type: FETCH_BEGIN });
const fetchSuccess = data => ({ type: FETCH_SUCCESS, payload: data });
const fetchFailed = error => ({ type: FETCH_FAILED, payload: error });
export const fetchDoctorListByAppointmentType = appointmentTypeName => async dispatch => {
  dispatch(fetchBegin());

  try {
    const res = await api(
      `retrieve-doctor-by-booking-type?booking_type_name=${appointmentTypeName}`
    );

    dispatch(fetchSuccess(res.data.result));
  } catch (error) {
    dispatch(fetchFailed(error.toString()));
    dispatch(setErrorNotification(error.toString()));
  }
};

const initialState = {
  data: [],
  isLoading: false,
  error: null
};

const reducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case FETCH_BEGIN:
      return { ...state, data: [], isLoading: true, error: null };
    case FETCH_SUCCESS:
      return { ...state, data: payload, isLoading: false };
    case FETCH_FAILED:
      return { ...state, error: payload, isLoading: false };

    default:
      return state;
  }
};

export default reducer;
